import PropTypes from "prop-types"
import React from "react"
import { usePageAssets } from "hooks/usePageAssets"
import Heading from "components/ui/Heading"
import SkewedSection from "components/ui/Layout/SkewedSection"
import SplitContainer from "components/ui/Layout/SplitContainer"

function EaseOfUseSection({ className }) {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("internal-tooling-ease-of-use")
  return (
    <SkewedSection className={className}>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="mt-8 md:mt-0 max-w-2xl mx-auto"
      >
        <Heading
          label="Ease of Use"
          title="Embed your dashboards in minutes"
          subtitle={
            <>
              Create dashboards for embedding in exactly the same way as any
              other dashboards. Using guest tokens and embedded SDK, dashboards
              are securely integrated in your custom app in just a few steps.
            </>
          }
          narrow
        />
      </SplitContainer>
    </SkewedSection>
  )
}

EaseOfUseSection.protoTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
}

export default EaseOfUseSection
